import React, { useEffect, useState } from 'react'
import {  makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'

import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import Button from '@material-ui/core/Button'

import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import TextField from '@material-ui/core/TextField'

import {
  updateSelectedZoomEvents,
  loadZoomEventsData
} from '../../actions'
import Link from '@material-ui/core/Link'

import { getZoomEvents, unMergeEvents } from '../../services/saga'

import MaterialTable from 'material-table'

import { connect } from 'react-redux'

import LinearProgress from '@material-ui/core/LinearProgress'
import LinkOffIcon from '@material-ui/icons/LinkOff'
import LinkIcon from '@material-ui/icons/Link'
import Fab from '@material-ui/core/Fab'
import { green } from '@material-ui/core/colors'
import CircularProgress from '@material-ui/core/CircularProgress'

import Chip from '@material-ui/core/Chip'
import GetAppIcon from '@material-ui/icons/GetApp'

import moment from 'moment-timezone'
import BrowserStore from 'store'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2)
  },
  table: {
    minWidth: 750
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1
  },
  Loading: {
    marginTop: '-41px'
  },

  cursorDef: {
    cursor: 'default'
  },
  fabProgress: {
    color: green[500],
    position: 'absolute',
    top: -6,
    left: -6,
    zIndex: 1
  },

  wrapper: {
    margin: theme.spacing(1),
    position: 'relative'
  },

  buttonSuccess: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700]
    }
  }
}))

const CourseTable = (props) => {
  const {
    data,
    zoomEvents,
    updateZoomEvents,
    onUpdateSelected,
    selectedEventIds,
    tableRef,
    refreshTable,
    setRefreshTable
  } = props

  const classes = useStyles()
  const [page, setPage] = React.useState(1)
  const [rowsPerPage, setRowsPerPage] = React.useState(20)
  const [calendarStartDate, setCalendarStartDate] = React.useState('')
  const [calendarEndDate, setCalendarEndDate] = React.useState('')


  const [tableLoading, setTableLoading] = React.useState(false)



  const configNextCalendarDays = 30

  const [currentProgressId, setCurrentProgressId] = useState(0)
  const [currentParentId, setCurrentParentId] = useState(0)

  let user_timezone = false

  const sessionData = BrowserStore.get('inseadCanvasAdmin')

  if (sessionData.hasOwnProperty('userProfile')) {
    user_timezone = sessionData.userProfile['time_zone']
    console.log('user_timezone', user_timezone)
  }

  // get calendar events
  // get called each status update
  async function getEvents() {
    let courseId = data.courseId

    if (courseId === 0) {
      return false
    }

    if (calendarStartDate === '') {
      calculateDates(new Date())
      return false
    }

    setTableLoading(true)

    let query = {
      page: page,
      pageSize: 100
    }

    let getData = await getZoomEvents(
      courseId,
      page,
      query.pageSize,
      null,
      calendarStartDate,
      calendarEndDate
    )

    let dataSet = {
      data: getData,
      method: 'ADD'
    }

    updateZoomEvents(dataSet)

    setTableLoading(false)
  }

  useEffect(() => {
    getEvents()
  }, [data.courseId, calendarStartDate])

  // refresh table data when needed. Manual trigger
  // setRefreshTable(true)
  useEffect(() => {
    if (refreshTable === true) {
      getEvents()
    }
  }, [refreshTable])

  const handleClose = () => {
    // updateCourseId(0);
    // updateZoomEvents({data:[],method:"CLEAR"})
    // setOpen(false);
  }

  // when user click check box, this event is triggered
  const handleClick = (rows, event) => {
    setCurrentParentId(0)

    // make unique
    let uniq = [...new Set(rows)]

    onUpdateSelected(uniq)
  }

  // when user change page
  const onChangePage = async (page) => {
    // setTableLoading(true)
    // let query = {
    //   page: page,
    //   pageSize: 5
    // }
    // let remoteData = await remoteDataTable(query);
    // setTableLoading(false)
  }

  // calculate date for next N days when needed.
  //
  const calculateDates = (StartDate) => {
    if (StartDate === '') {
      return false
    }

    let today = new Date(StartDate).toISOString().slice(0, 10)
    let next30Days = new Date(StartDate)
    next30Days.setDate(next30Days.getDate() + configNextCalendarDays)
    next30Days = next30Days.toISOString().slice(0, 10)

    let start_date = today
    let end_date = next30Days

    setCalendarStartDate(start_date)
    setCalendarEndDate(end_date)
  }

  const handleDateChange = (event) => {
    //check for change and update accordingly
    if (event.target.value !== calendarStartDate) {
      calculateDates(event.target.value)
    }
  }

  // when user click un merge this event triggered
  const handleUnMerge = async (event) => {
    setRefreshTable(false)

    let payload = {
      event: event
    }

    setCurrentProgressId(event.id)
    setCurrentParentId(event.zoom_parent_id)

    let mergeEvents = await unMergeEvents(payload)
    setRefreshTable(true)

    setCurrentProgressId(0)
  }

  // this data will be showed in the table as rows.
  // if you need to apply any conditions, apply here
  let filterRows = zoomEvents.data.map((data) => {
    let isChecked = selectedEventIds.data
      .map((event) => event.id)
      .includes(data.id)

    return {
      ...data,
      tableData: { ...data.tableData, checked: isChecked, isTreeExpanded: true }
    }
  })

  // get only parent events, quick fix for canvas api
  filterRows = filterRows.filter((item) => item.parent_event_id === null)

  const headCells = [
    {
      field: 'id',
      numeric: true,
      disablePadding: false,
      title: 'Canvas Event ID',

      headerStyle: {
        color: '#015548'
      },

      render: (row) => (
        <Link
          href='#'
          onClick={() =>
            window.open(
              process.env.REACT_APP_CANVAS_DOMAIN +
                'courses/' +
                data.courseId +
                '/calendar_events/' +
                row.id,
              '_blank'
            )
          }
        >
          <Tooltip title='Link will open in a new tab'>
            <span>{row.id}</span>
          </Tooltip>
        </Link>
      )
    },
    {
      field: 'te_reservation_id',
      numeric: true,
      disablePadding: false,
      title: 'TE Reservation ID',

      headerStyle: {
        color: '#015548'
      },

      render: (row) => (
          <Link
              href='#'
              onClick={() =>
                  window.open(
                      process.env.REACT_APP_CANVAS_DOMAIN +
                      'courses/' +
                      data.courseId +
                      '/calendar_events/' +
                      row.id,
                      '_blank'
                  )
              }
          >
            <Tooltip title='Link will open in a new tab'>
              <span>{row.te_reservation_id}</span>
            </Tooltip>
          </Link>
      )
    },
    {
      field: 'title',
      numeric: false,
      disablePadding: false,
      title: 'Title',
      headerStyle: {
        color: '#015548'
      }
    },

    {
      field: 'start_at',
      numeric: true,
      disablePadding: false,
      title: `Date (${user_timezone})`,
      headerStyle: {
        color: '#015548'
      },
      render: (row) => {
        return moment.tz(row.start_at, user_timezone).format('ddd, Do MMM YYYY')
      }
    },

    {
      field: 'start_at',
      numeric: true,
      disablePadding: false,
      title: `Time (${user_timezone})`,
      headerStyle: {
        color: '#015548'
      },
      render: (row) => {
        return (
          moment.tz(row.start_at, user_timezone).format('H:mm') +
          ' to ' +
          moment.tz(row.end_at, user_timezone).format('H:mm')
        )
      }
    },

    {
      field: 'zoom_link',
      numeric: false,
      disablePadding: false,
      title: 'Zoom Link',
      headerStyle: {
        color: '#015548'
      }
    },

    {
      field: 'zoom_owner',
      numeric: false,
      disablePadding: false,
      title: 'Zoom Host',
      headerStyle: {
        color: '#015548'
      }
    },

    {
      field: 'zoom_alternative_host',
      numeric: false,
      disablePadding: false,
      title: 'Co Host',
      headerStyle: {
        color: '#015548'
      },
      render: (row) => {
        let coHost = row?.zoom_alternative_host

        if (coHost === '' || coHost === null || coHost === undefined) {
          return false
        }

        coHost = coHost.split(',')

        return coHost.map((item) => (
          <Chip size='small' style={{ marginBottom: 5 }} label={item} />
        ))
      }
    },

    {
      field: 'zoom_visibility',
      numeric: false,
      disablePadding: false,
      title: 'Zoom Link Visibility',
      headerStyle: {
        color: '#015548'
      },
      render: (rowData) => {
        let publishIcons =
          rowData.zoom_visibility == 1 ? (
            <Tooltip title='Zoom link is published.'>
              <CheckCircleIcon style={{ color: '#3fa978' }} />
            </Tooltip>
          ) : (
            <Tooltip title='Zoom link is hidden'>
              <CheckCircleOutlineIcon style={{ color: '#b1b1b1' }} />
            </Tooltip>
          )
        let deleteIcons =
          rowData.zoom_parent_id != null ? (
            <div className={classes.wrapper}>
              <Fab aria-label='save' size='small'>
                <Tooltip title='Unmerge'>
                  <IconButton
                    onClick={() => handleUnMerge(rowData)}
                    aria-label='delete'
                  >
                    <LinkOffIcon style={{ color: 'red' }} />
                  </IconButton>
                </Tooltip>
              </Fab>

              {currentProgressId === rowData.id ? (
                <CircularProgress size={52} className={classes.fabProgress} />
              ) : null}
            </div>
          ) : null

        let count = filterRows.filter(
          (item) =>
            item.zoom_parent_id !== null && rowData.id === item.zoom_parent_id
        )

        let countRender =
          count.length !== 0 ? (
            <Tooltip title={` This event has ${count.length} merged events `}>
              <IconButton
                className={[classes.cursorDef].join(' ')}
                aria-label='delete'
              >
                <LinkIcon />
              </IconButton>
            </Tooltip>
          ) : null

        return (
          <div>
            {publishIcons} {countRender} {deleteIcons}
          </div>
        )
      }
    },

    {
      field: 'download',
      numeric: false,
      disablePadding: false,
      title: 'Download Calendar (ICS) File  ',
      headerStyle: {
        color: '#015548'
      },
      render: (row) => {
        let meetingLink = row.zoom_link

        if (
          meetingLink === null ||
          meetingLink === '' ||
          meetingLink === undefined
        ) {
          return <span>N/A</span>
        }

        let zoomId = meetingLink.match(/(.us\/[a-z]\/\d+)/gm)

        if (zoomId !== null) {
          zoomId = zoomId[0].replace(/(.us\/[a-z]\/)/gm, '')

          return (
            <Button
              size='small'
              variant='contained'
              style={{ fontSize: '10px' }}
              onClick={() =>
                window.open(
                  `https://insead.zoom.us/meeting/${zoomId}/ics`,
                  '_blank'
                )
              }
              color='primary'
            >
              <GetAppIcon fontSize='small' /> Download
            </Button>
          )
        }
      }
    }
  ]

  console.log('filterRows',filterRows);
  console.log('zoomEvents',zoomEvents);

  return (
    <div>
      <Paper>
        {tableLoading ? <LinearProgress /> : null}

        <MaterialTable
          title={`Calendar Events from ${calendarStartDate} to Next ${configNextCalendarDays} Days`}
          // tableRef={tableRef}
          isLoading={tableLoading}
          columns={headCells}
          data={filterRows}
          parentChildData={(row, rows) =>
            rows.find((a) =>  a.id_local !== null && a.id_local === row.zoom_parent_id)
          }
          options={{
            showSelectAllCheckbox: true,
            // initialPage: 1,
            search: true,
            // paging: true,
            selection: true,
            selectionProps: (row) => ({ disabled: row.zoom_parent_id }),

            pageSize: rowsPerPage,
            emptyRowsWhenPaging: false,
            pageSizeOptions: [5, 20, 100]

            // rowStyle: rowData => ({
            //   backgroundColor: (rowData.tableData.isTreeExpanded) ? '#EEE' : '#FFF'
            // })
            // filtering: true
          }}
          localization={{
            body: {
              emptyDataSourceMessage:
                tableLoading === true
                  ? 'Loading..'
                  : `Couldn't find the calendar events.`
            }
          }}
          onSelectionChange={handleClick}
          onChangeRowsPerPage={(pageSize) => {
            setRowsPerPage(pageSize)
          }}
          actions={[
            {
              icon: () => (
                <TextField
                  id='date'
                  type='date'
                  defaultValue={calendarStartDate}
                  // className={classes.textField}
                  InputLabelProps={{
                    shrink: true
                  }}
                  onChange={handleDateChange}
                />
              ),
              tooltip: 'Calendar',
              isFreeAction: true
              // onClick: (event) => handleDateChange(event)
            }
          ]}
          onChangePage={onChangePage}
        />
      </Paper>
    </div>
  )
}

// }

function mapStateToProps(state) {
  return {
    data: state.ZoomMeetings,
    selectedEventIds: state.ZoomMeetings.selectedEventIds,
    zoomEvents: state.ZoomMeetings.events
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateZoomEvents: (data) => {
    dispatch(loadZoomEventsData(data))
  },

  onUpdateSelected: (data) => {
    dispatch(updateSelectedZoomEvents(data))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(CourseTable)
